export default __webpack_public_path__ + "static/char-s-55-ko-4c8be71e78ab8303fa45aa7264fc7e92.png";